// React
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import './i18next';

// Components
import App from './app/App';
import { BrowserRouter } from 'react-router-dom';

// Styles
// !!! be careful https://stackoverflow.com/questions/70367443/create-react-app-with-typescript-failing-to-compile-after-importing-semantic-ui
// import 'semantic-ui-css/semantic.min.css';
// import "fomantic-ui-css/semantic.min.css";
import './index.css';

import { createRoot } from 'react-dom/client';

const rootElement = document.getElementById('app');
const root = createRoot(rootElement as HTMLElement);

root.render(
    <React.StrictMode>
        <BrowserRouter basename="/">
            <HelmetProvider>
                <App />
            </HelmetProvider>
        </BrowserRouter>
    </React.StrictMode>
);
